import type { ReactNode } from 'react';

import styles from './SidePanelHeader.module.scss';

export interface SidePanelHeaderProps {
  title: string;
  icon?: ReactNode;
  onClose: () => void;
  trailing?: ReactNode;
}

export const SidePanelHeader = ({ title, icon, onClose, trailing }: SidePanelHeaderProps) => (
  <div className={styles.headerTop}>
    <button className={styles.closeButton} onClick={onClose} aria-label="Close panel">
      ×
    </button>
    <div className={styles.titleRow}>
      {icon && <span className={styles.titleIcon}>{icon}</span>}
      <h2 className={styles.title}>{title}</h2>
    </div>
    {trailing && <div className={styles.trailing}>{trailing}</div>}
  </div>
);
